module.exports = __webpack_public_path__ + "img/bldg1512-h-474x356.b73277b3.jpg";